export default "__VITE_ASSET__yCeRBTwi__"